import axios from "axios"
import get from "lodash/get"
import { urls } from "utils-lib/builds"
import {
  SET_RO_LEADS_PENDING,
  SET_RO_LEADS_FULFILLED,
  SET_RO_LEADS_FAILED,
  RESET_SET_RO_LEADS,
  SET_IS_RO_CUSTOMER,
  SET_STEP3_BUTTON_CLICKED,
  SET_IS_LANDED_EVENT,
} from "constants-lib/actionTypes"
import { generateUniqueID } from "utils-lib/requests"

export const setROLeadsPending = () => ({
  type: SET_RO_LEADS_PENDING,
})

export const setROLeadsFulfilled = (data) => ({
  type: SET_RO_LEADS_FULFILLED,
  payload: data,
})

export const setROLeadsFailed = (error) => ({
  type: SET_RO_LEADS_FAILED,
  payload: error,
})

export const setIsROCustomer = (isFromROFlow) => ({
  type: SET_IS_RO_CUSTOMER,
  payload: isFromROFlow,
})

export const setStep3Call = (isCheckAvailabilityButtonClicked) => ({
  type: SET_STEP3_BUTTON_CLICKED,
  payload: isCheckAvailabilityButtonClicked,
})
export const setIsLandedEventLoaded = (isLandedEventLoaded) => ({
  type: SET_IS_LANDED_EVENT,
  payload: isLandedEventLoaded,
})

export const resetSetROLeads = () => ({
  type: RESET_SET_RO_LEADS,
})

export const setROLeads =
  (payload, recaptchaToken, recaptchaAction) => (dispatch) => {
    dispatch(setROLeadsPending())
    const apiKey = get(urls, "apiKey.GUEST.ROLLOFF_LEADS", "")
    const endpoint = urls.url.ROLLOFF_LEADS

    const client = axios.create({
      headers: {
        "Content-Type": "application/json",
        "x-api-key": apiKey,
        "Request-Tracking-Id": generateUniqueID(),
        Authorization: recaptchaToken,
        "recaptcha-action": recaptchaAction,
      },
    })

    return client
      .post(endpoint, {
        query: `
          mutation PutPost($data: AWSJSON!) {
            putPost(body: $data) {
              status message response {
               id
                status
                 actionCd 
                 } 
                 }
                 }`,
        variables: {
          data: JSON?.stringify(payload),
        },
      })
      .then((response) => {
        const data = get(response, `data`, {})
        dispatch(setROLeadsFulfilled(data))
        return data
      })
      .catch((error) => {
        dispatch(setROLeadsFailed(get(error, "response.data", error.message)))
        throw error
      })
  }
